import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiLink } = FiIcons;

const URLInput = ({ value, onChange }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="space-y-3"
    >
      <label className="flex items-center space-x-2 text-sm font-medium text-slate-300">
        <SafeIcon icon={FiLink} className="w-4 h-4 text-blue-400" />
        <span>URL to redirect</span>
      </label>
      
      <div className="relative">
        <input
          type="url"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://example.com"
          className="w-full px-4 py-3 bg-slate-800/50 border border-slate-700/50 rounded-xl text-slate-200 placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500/50 transition-all duration-200"
        />
      </div>
      
      {value && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="text-xs text-slate-400 bg-slate-800/30 rounded-lg p-3 border border-slate-700/30"
        >
          <strong>Base64 encoded:</strong> {btoa(value)}
        </motion.div>
      )}
    </motion.div>
  );
};

export default URLInput;